<div [formGroup]="input_form">
  <form-field
    class="tw-w-full tw-relative"
    label="common.winnerCount"
    [min]="1"
    [(value)]="value"
    (valueChange)="emit($event)"
    type="tel"
    classList="tw-text-lg tw-pr-3 font-vazir-ui tw-text-right dir-ltr"
    [isOnlyNumber]="true"
  >
    <div content>
      <!--#region count -->
      <div
        class="tw-flex-center text-navyBlue tw-absolute btn-sm tw-cursor-pointer bg-color"
        style="left: 0; top: 0; bottom: 0; border: unset"
      >
        <span class="text-submit-discount-btn rounded" [themeColor]="'btn'">
          <p
            *ngIf="!loading"
            class="tw-mb-2 tw-mt-2 tw-pl-2 tw-pr-2 text-icon text-white"
            (click)="onSubmit()"
          >
            {{ "common.pollParserLottery" | translate }}
          </p>

          <!-- loading -->
          <ng-container *ngIf="loading" class="tw-px-1">
            <div
              class="tw-mb-2 tw-mt-2 tw-pl-2 tw-pr-2 text-icon text-white tw-text-center"
            >
              <span
                class="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
              <span class="sr-only">Loading...</span>
            </div>
          </ng-container>
        </span>
      </div>
      <!--#endregion -->
    </div>
  </form-field>
</div>
